import React from 'react';
import clsx from 'clsx';

interface Props {
	additionalClass?: string;
}

export const ButtonLoading = ({ additionalClass }: Props): React.ReactElement => {
	return (
		<span className={clsx('indicator-progress text-center d-block', additionalClass)} data-cy="button-loading">
			<span className="spinner-border spinner-border-sm align-middle"/>
        </span>
	);
};
